let matchPlayers = {}

export const setMatchPlayer = ({ oTeam1, oTeam2 }) => {
  if (oTeam1?.aPlayers?.length || oTeam2?.aPlayers?.length) {
    const oTeam1TotalPlayer = oTeam1?.aPlayers?.length
    const allPlayers = [...oTeam1?.aPlayers, ...oTeam2?.aPlayers]
    const player = {}
    allPlayers.forEach((p, i) => {
      player[p?.oPlayer?._id] = {
        ...p,
        ...p?.oPlayer,
        oTeam: i > oTeam1TotalPlayer ? oTeam2?.oTeam : oTeam1?.oTeam
      }
    })
    matchPlayers = player
  }
}

export const getMatchPlayers = () => matchPlayers

export const useMatchFormat = (key) => {
  switch (key) {
    case 'odi':
      return 'ODI'
    case 'lista':
      return 'List A'
    case 't20i':
      return 'T20I'
    case 'woment20':
      return 'Women T20'
    case 'womenodi':
      return 'Women ODI'
    default:
      return key
  }
}
